import { BOProduct, StockLevelStatusEnum } from '@boels/models';
import { JsonLdBuilder } from '../../structured-data.model';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class JsonLdProductOfferBuilder implements JsonLdBuilder<BOProduct> {
  build(product: BOProduct): Observable<any> {
    const schema: {
      '@type': string;
      price?: string;
      priceCurrency?: string;
      availability?: string;
      lowPrice?: number;
    } = { '@type': 'Offer' };

    if (product?.unitPrices?.length && product.unitPrices[0].sdFormattedValue) {
      schema.price = product.unitPrices[0].sdFormattedValue;
      if (product.unitPrices[0].currencyIso) {
        schema.priceCurrency = product.unitPrices[0].currencyIso;
      }
    } else {
      schema['@type'] = 'AggregateOffer';
      schema.lowPrice = 0;
      if (product.price?.currencyIso) {
        schema.priceCurrency = product.price.currencyIso;
      }
    }

    if (product.stock && product.stock.stockLevelStatus) {
      schema.availability =
        product.stock.stockLevelStatus === StockLevelStatusEnum.IN_STOCK
          ? StockLevelStatusEnum.IN_STOCK
          : StockLevelStatusEnum.OUT_OF_STOCK;
    }

    return of({ offers: schema });
  }
}
